import ApiClient from './ApiClient';
import UserInfo from '../models/UserInfo';
import UserLookupObject from '../models/UserLookupObject';

export default class UsersService extends ApiClient {
	async getMyInfo() {
		return this.get<UserInfo>('Users/me');
	}

	async getById(id:string) {
		return this.get<UserInfo>(`Users/${id}`);
	}

	async userLookup(name:string, abortSignal?: AbortSignal) {
		return this.get<UserLookupObject[]>(`Users?nameFilter=${name}&maxRows=10`, abortSignal);
	}

	async employeeUserLookup(name: string, abortSignal?: AbortSignal) {
		return this.get<UserLookupObject[]>(`Users/employees?nameFilter=${name}&maxRows=10`, abortSignal);
	}

	async AppAdminEmployeeUserLookup(name: string, abortSignal?: AbortSignal) {
		return this.get<UserLookupObject[]>(`Users/employees?nameFilter=${name}&maxRows=10&IsAppAdminEmployee=true`, abortSignal);
	}

	async subsOwnerUserLookup(name: string, abortSignal?: AbortSignal) {
		return this.get<UserLookupObject[]>(`Users/subscriptionOwners?nameFilter=${name}&maxRows=10`, abortSignal);
	}

	async accsOwnerOrCustodianUserLookup(name: string, isAWSAccountOwner: boolean = false, abortSignal?: AbortSignal) {
		return this.get<UserLookupObject[]>(`Users/awsAccountOwnersOrCustodian?nameFilter=${name}&maxRows=10&isAWSAccountOwner=${isAWSAccountOwner}`, abortSignal);
	}
}